import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=17465f63&scoped=true&"
import script from "./ListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=17465f63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17465f63",
  null
  
)

export default component.exports